import React from 'react';
import { Form, FormControl, InputGroup } from 'react-bootstrap';
import { FaHandshake } from 'react-icons/fa';
import { FiEdit, FiEye, FiTrash2 } from 'react-icons/fi';
import { AiOutlineBank } from "react-icons/ai";
import {
  useGlobalFilter,
  usePagination,
  useSortBy,
  useTable,
} from 'react-table';
import GlobalFilter from '../GlobalFilter';
import './table.css';

// eslint-disable-next-line import/no-anonymous-default-export
export default (props) => {
  let columns = props.columns;
  let data = props.data;
  let showModal = props.showModal;
  let showDeleteModal = props.showDeleteModal;
  let showFilterModal = props.showFilterModal;
  let showSearch = props.showSearch;
  let showView = props.showView;
  let showBank = props.showBank;
  let bankInfoModalHandler = props.bankInfoModalHandler;
  let edit = props.edit;
  const showLocationModal = props.showLocationModal
    ? props.showLocationModal
    : false;

  const tableHooks = (hooks) => {
    hooks.visibleColumns.push((columns) => [
      ...columns,
      {
        id: 'contacts',
        Header: 'Actions',
        Cell: ({ row }) => {
          return (
            <div class="tableActions">
              {
                showBank && (
                  <button
                  id="bAcep"
                  type="button"
                  class="btn  btn-sm btn-height"
                  title="Bank Info"
                  style={{ 'font-size': '0.9rem' }}
                  onClick={() => bankInfoModalHandler(row.original)}
                >
                 <i class="fa fa-university" aria-hidden="true"></i>
                </button>
                )
              }
              {showView && (
                <button
                  id="bAcep"
                  type="button"
                  class="btn  btn-sm btn-height"
                  title="View Contacts"
                  style={{ 'font-size': '1.1rem' }}
                  onClick={() => showModal(row.original)}
                >
                  <FiEye />
                </button>
              )}

              {showLocationModal && (
                <button
                  id="bEdit"
                  type="button"
                  class="btn btn-sm btn-height"
                  title="Edit"
                  style={{ 'font-size': '1.1rem' }}
                  onClick={() => showLocationModal(row.original)}
                >
                  <FaHandshake />
                </button>
              )}
              <button
                id="bEdit"
                type="button"
                class="btn btn-sm btn-height"
                title="Edit"
                style={{ 'font-size': '1.1rem' }}
                onClick={() => edit(row.original)}
              >
                <FiEdit />
              </button>
              <button
                id="bDel"
                type="button"
                class="btn  btn-sm btn-height"
                title="Delete"
                style={{ 'font-size': '1.1rem' }}
                onClick={() => showDeleteModal(row.original)}
              >
                <FiTrash2 />
              </button>
            </div>
          );
        },
      },
    ]);
  };

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    state,
    setGlobalFilter,
    nextPage,
    previousPage,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    setPageSize,
  } = useTable(
    {
      columns,
      data,
      initialState: {
        pageSize:100
    },
    },
    useGlobalFilter,
    useSortBy,
    usePagination,
    tableHooks,
   
  );

  const { globalFilter, pageIndex, pageSize } = state;

  return (
    <>
      <div class="d-flex justify-content-between align-items-center pt-2">
      <div>
        <Form>
          <div className="d-flex align-items-center">
            <label class="mb-0 pe-2">Show</label>
              <FormControl
                as="select"
                custom
                value={pageSize}
                onChange={(e) => setPageSize(Number(e.target.value))}
                size="form-conrol form-select select2">
                {[10, 25, 50, 100].map((item) => (
                  <option key={item} value={item}>
                    {item}
                  </option>
                ))}
              </FormControl>
              <span className="Entries"> entries</span>
          </div>
          
        </Form>
      </div>
      
      <div>
        {showSearch && (
            <GlobalFilter
              filter={globalFilter}
              setFilter={setGlobalFilter}
              showFilterModal={showFilterModal}
            />
        )}
      </div>
    </div>
    <div className='table-scrollable '>
      <table
        {...getTableProps()}
        // id="myTable"
        // class="display table dataTable no-footer"
        className='table dataTable no-footer girdtable scrollme'
        // width="100%"
        // role="grid"
        // aria-describedby="myTable_info"
      >
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                  {column.render('Header')}
                  <span class="pull-right sorting-icon">
                    {column.isSorted ? (column.isSortedDesc ? '↓' : '↑') : '↓↑'}
                  </span>
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {page.map((row) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map((cell) => {
                  return (
                    <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
      </div>  
      <div class="d-flex justify-content-between p-2">
        <div>
          <span>
            Page{' '}
            <strong>
              {pageIndex + 1} of {pageOptions.length}
            </strong>
          </span>
        </div>
        <div class="d-flex align-items-center">
            <span class="d-flex align-items-center pe-2">
              Go to page:{' '}
              {/* <input
                type="number"
                defaultValue={pageIndex + 1}
                onChange={(e) => {
                  const pageNumber = e.target.value
                    ? Number(e.target.value) - 1
                    : 1;
                  gotoPage(pageNumber);
                }}
                style={{ width: '50px' }}
              /> */}
            </span>
        {/* <button
          class="pageButton"
          onClick={() => gotoPage(0)}
          disabled={!canPreviousPage}
        >
          {'<<'}
        </button>
        <button
          class="pageButton"
          onClick={() => previousPage()}
          disabled={!canPreviousPage}
        >
          {' '}
          Previous{' '}
        </button>
        <button
          class="pageButton"
          onClick={() => nextPage()}
          disabled={!canNextPage}
        >
          {' '}
          Next{' '}
        </button>
        <button
          class="pageButton"
          onClick={() => gotoPage(pageCount - 1)}
          disabled={!canNextPage}
        >
          {'>>'}
        </button> */}
        <div class="btn-group" role="group" aria-label="Basic outlined example">
            <button onClick={() => gotoPage(0)} disabled={!canPreviousPage} class="btn btn-outline-secondary"> {'<<'}</button>
            <button onClick={() => previousPage()} disabled={!canPreviousPage} class="btn btn-outline-secondary">{'⟨'}</button>
            <input
              className="btn btn-outline-secondary"
              type="number"
              placeholder={pageIndex + 1}
              defaultValue={pageIndex + 1}
              min="1"
              max={pageOptions.length}
              onChange={(e) => {
                const pageNumber = e.target.value
                  ? Number(e.target.value) - 1
                  : 1;
                gotoPage(pageNumber);
              }}
              style={{ width: '60px',padding:'5px'}}
            />
            <button onClick={() => nextPage()} disabled={!canNextPage} class="btn btn-outline-secondary">{'⟩'}</button>
            <button onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage} class="btn btn-outline-secondary">{'>>'}</button>
          </div>
      </div>
      </div>
    </>
  );
};
